'use strict';

module.exports = paragraph;

var all = require('../all');

/* Transform a paragraph. */
function paragraph(h, node) {
  return h(node, 'p', all(h, node));
}



//////////////////
// WEBPACK FOOTER
// ./~/remark-html/~/mdast-util-to-hast/lib/handlers/paragraph.js
// module id = 230
// module chunks = 96961042003272 139266963665775